import React from 'react';
import PaymentContainer from '../../../components/modules/Balance/Payment/Index';

const Payment = () => <PaymentContainer />;

export default Payment;
